
import { Component, Vue, Prop } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import u from '@/utility/utility';
import DeliveryInfo from './components/DeliveryInfo.vue';
import { Order } from '@/models/order';
import { Customer } from '@/models/customer';
import authService from '@/services/auth-services';
import orderService from '@/services/order-service';
import paymentRequestServices from '@/services/payment-request-services';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';

@Component({
    components: {
        Loading,
        'delivery-info': DeliveryInfo,
        ConfirmModal
    }
})
export default class AddNewPaymentRequest extends Vue {
    private customerInfo: Customer = {};
    private isLoading = false;
    private otherOption = {
        shippingMethod: 0,
        customerNote: '',
        appendToAddressBook: false
    };
    
    private isConfirm = false;
    private modalContent = '';
    private selectedAddress: any = {};

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get paymentRequestOrders() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].paymentRequestOrders;
    }

    get totalChoose() {
        return this.paymentRequestOrders ? this.paymentRequestOrders.filter(x => x.isChecked === true).length : 0;
    }

    get totalWeight() {
        return this.paymentRequestOrders ? this.paymentRequestOrders.reduce((total: number, order: Order) => {
            return total + (order.isChecked ?  (order.orderWeight || 0) : 0);
        }, 0) : 0;
    }

    get totalAmount() {
        return this.paymentRequestOrders ? this.paymentRequestOrders.reduce((total: number, order: Order) => {
            return total + (order.isChecked ?  (order.totalAmountVND || 0) : 0);
        }, 0) : 0;
    }

    get totalDeposit() {
        return this.paymentRequestOrders ? this.paymentRequestOrders.reduce((total: number, order: Order) => {
            return total + (order.isChecked ? (order.deposit || 0) : 0);
        }, 0) : 0;
    }

    private async created() {
        this.getCustomersInfo();
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
                this.customerInfo = {
                    ...result.data.data
                };
            }
        }
    }
    private async backToPrevious() {
        this.$router.push({ name: 'payment-request-new' });
    }
    private async submitPaymentRequest() {
        const isValid = await (this.$refs['observer'] as any).validate();
        if (isValid) {
            this.isLoading = true;
            const dataRequest = {
                UID: this.userInfo.userId,
                Username: this.userInfo.userName,
                TotalAmount: this.totalAmount,
                TotalPayment: this.totalDeposit,
                TotalOrder: this.totalChoose,
                ReceiverName: this.selectedAddress.Receiver,
                ReceiverPhone: this.selectedAddress.Phone,
                ReceiverAddress: this.selectedAddress.Address,
                ShippingMethod: this.otherOption.shippingMethod,
                CustomerNote: this.otherOption.customerNote,
                Orders: this.paymentRequestOrders
            };

            const result = await paymentRequestServices.createPaymentRequest(dataRequest);
            this.isLoading = false;
            if (result && result.status === 200 && result.data.status === 200) {
                // New customer address
                if (this.otherOption.appendToAddressBook) {
                    const custDataRequest = {
                        UID: this.userInfo.userId,
                        Receiver: this.selectedAddress.Receiver,
                        Address: this.selectedAddress.Address,
                        Phone: this.selectedAddress.Phone,
                    }
                    await authService.newAddressInfo(custDataRequest);
                }
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Tạo mới yêu cầu giao hàng thành công!',
                });
                this.getCustomersInfo();
                (window['getApp'] as any).$emit('SET_SELECTED_ORDER', []);
                this.$router.push({ name: 'payment-request-detail', params: { id: result.data.data.ID.toString() } }).catch(() => {
                    return false;
                });
            } else if (result && result.status === 202) {
                if (result.data.error === 'Số dư ví không đủ để thanh toán') {
                    this.modalContent = '<div style="color: #111;">Số tiền trong ví của bạn không đủ.</div><div class="text-danger">Hãy nạp tiền để tiếp tục thanh toán!</div>';
                    this.isConfirm = true;
                } else {
                    Vue.notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Thông báo!',
                        text: result.data.error,
                    });
                }
                
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Có lỗi trong quá trình xử lý dữ liệu!',
                });
            }
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private onOtherModalWallet(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.$router.push({ name: 'profile' });
        }
    }
}
